import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IhmAutocompleteChipsListComponent } from './ihm-autocomplete-chips-list.component';
import { IhmPipesModule } from './../../shared/pipes/ihm-pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    IhmPipesModule
  ],
  declarations: [IhmAutocompleteChipsListComponent],
  exports: [IhmAutocompleteChipsListComponent]
})
export class IhmAutocompleteChipsListModule {}
